<template>
    <div class="visible-user-picker">

        <!-- Button -->
        <div @click.stop="showSelector">{{ label }}</div>

        <!-- Modal -->
        <div ref="picker"
             class="modal fade visible-user-picker-modal"
             role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Change Visible User</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader">
                            <input type="text" class="form-control" v-model="userFilter" ref="filter"
                                   placeholder="Search for email or last name"/>
                        </div>

                        <div class="modal-scroll-area">
                            <visible-user-list
                                    ref="list"
                                    :filter="userFilter"
                                    @select="selectUser"
                            ></visible-user-list>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><span class="fa fa-times"></span> Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .visible-user-picker {
        display: inline-block;

        .text {
            background: transparent;
            cursor: pointer;
            border: none;
            padding: 0px;
        }
    }

    .visible-user-picker-modal .modal-body > *:first-child {
        border-top: 1px solid $border-gray;
        border-bottom: 1px solid $border-gray;
        max-height: 300px;
        overflow: auto;
    }

    .visible-user-picker-search {
        padding: 20px;
        background-color: #f8f9fb;
        border-bottom: 1px solid #f1f1f1;
    }

</style>

<script>
    export default {
        props: {
            type: { default: 'text' },
            label: { default: 'Change Visible User' }
        },

        data: function() {
            return {
                picker: null,
                userFilter: ''
            }
        },

        methods: {
            showSelector: function() {
                this.picker.modal('show');
                setTimeout(this.setFocus,250);
            },

            setFocus: function() {
                this.$refs.filter.select();
            },

            selectUser: function(user_id) {
                var request = this.$http.post('/admin/change-visible-user', { user_id: user_id });
                request.then(function(response) {
                    var user = response.body;
                    this.picker.modal('hide');
                    window.location.href = '/';
                });
            }
        },

        mounted: function() {
            this.picker = $(this.$refs.picker);
            $('body').append(this.picker);
        }
    }

</script>



// WEBPACK FOOTER //
// visible-user-picker.vue?6153d108